module.exports = __webpack_public_path__ + "img/sld_scb_17_t1_b1.0ed0a5a1.svg";